import { render, staticRenderFns } from "./IkpMedParamsExcessMeasurement.vue?vue&type=template&id=3e21efc6&scoped=true"
import script from "./IkpMedParamsExcessMeasurement.vue?vue&type=script&lang=js"
export * from "./IkpMedParamsExcessMeasurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e21efc6",
  null
  
)

export default component.exports